import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';


class AboneFaturaItirazAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "AboneFaturaItirazListe";
    super(baseUrl);
  }


  getAboneFaturaItirazListe(yili: number,aboneNo: number,sicilKodu: number){
    
        var request= new AbonelerListeRequest(yili,aboneNo,sicilKodu);
    return this.post("", request, false);
   
  }

}
export default new AboneFaturaItirazAPI();
class AbonelerListeRequest {
  public yili: number;
  public aboneNo: number;
  public sicilKodu: number;
  constructor(yili: number,aboneNo: number,sicilKodu: number) {
   
      this.aboneNo = aboneNo;
      this.yili=yili;
      this.sicilKodu=sicilKodu;

  }
}
export { AbonelerListeRequest };